import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=22aec258&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22aec258')) {
      api.createRecord('22aec258', component.options)
    } else {
      api.reload('22aec258', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=22aec258&", function () {
      api.rerender('22aec258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/date-picker/base/confirm.vue"
export default component.exports